import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LOGIN_ROUTE } from "shared/constants/routes";
import history from "shared/plugins/history";
import { getCurrentStaff } from "states/staff/staff.api";
import { getProfile } from "./account.api";
import { AccountState, LoginResponse } from "./account.models";

const tokenName = "appToken";

const getToken = () => {
  const storageValue = localStorage.getItem(tokenName);
  return storageValue && storageValue !== ""
    ? (JSON.parse(storageValue) as LoginResponse)
    : ({} as LoginResponse);
};
const removeToken = () => localStorage.removeItem(tokenName);
const setToken = (token?: LoginResponse) => {
  localStorage.setItem(tokenName, token ? JSON.stringify(token) : "");
};

export const fetchProfile = createAsyncThunk(
  "account/fetchUser",
  async (_, thunkApi) => {
    try {
      const profile = await getProfile();
      return profile;
    } catch (error) {
      thunkApi.rejectWithValue(error);
      throw error;
    }
  }
);

export const login = createAsyncThunk<void, LoginResponse>(
  "account/login",
  async (model, thunkApi) => {
    try {
      setToken(model);
      thunkApi.dispatch(accountSlice.actions.setLoginUser(model));
    } catch (error) {
      throw new Error();
    }
  }
);

export const logout = createAsyncThunk(
  "account/logout",
  async (any, thunkApi) => {
    try {
      removeToken();
      thunkApi.dispatch(accountSlice.actions.setLogoutUser());
      history.push(LOGIN_ROUTE);
    } catch (error) {
      throw new Error();
    }
  }
);

export const fetchCurrentStaff = createAsyncThunk(
  "account/fetchCurrentStaff",
  async () => {
    try {
      const staff = await getCurrentStaff();
      return staff;
    } catch (error) {
      throw new Error();
    }
  }
);

export const accountSlice = createSlice({
  name: "account",
  initialState: {
    currentUser: undefined,
    currentStaff: undefined,
    token: getToken(),
    isAuthentication: false,
  } as AccountState,
  reducers: {
    setLogoutUser(state) {
      state.isAuthentication = false;
      state.currentUser = undefined;
      state.currentStaff = undefined;
      state.token = {};
    },
    setLoginUser(state: AccountState, action: PayloadAction<LoginResponse>) {
      state.token = action.payload;
      state.isAuthentication = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProfile.fulfilled, (state, action) => {
      state.currentUser = action.payload;
      state.isAuthentication = true;
    });
    builder.addCase(fetchCurrentStaff.fulfilled, (state, action) => {
      state.currentStaff = action.payload;
    });
  },
});
